import { SVGProps, Ref, forwardRef } from 'react';

export const FrameStarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M.5 5.24C.788 1.867 1.868.787 5.24.5v1.405c-.36.034-.68.077-.97.131-.872.165-1.307.407-1.567.667s-.502.695-.667 1.568q-.08.432-.13.968z"
                    fill="currentColor"
                />
                <path
                    d="M10.76.5v1.405c.36.034.68.077.97.131.872.165 1.307.407 1.567.667s.502.695.667 1.568q.08.432.13.968H15.5C15.212 1.868 14.132.79 10.76.5"
                    fill="currentColor"
                />
                <path
                    d="M11.73 13.964c-.29.054-.61.097-.97.13V15.5c3.372-.288 4.452-1.368 4.74-4.74h-1.405c-.034.36-.077.68-.131.97-.165.872-.407 1.307-.667 1.567s-.695.502-1.568.667"
                    fill="currentColor"
                />
                <path
                    d="M2.036 11.73a11 11 0 0 1-.13-.97H.5c.288 3.372 1.368 4.452 4.74 4.74v-1.405c-.36-.034-.68-.077-.97-.131-.872-.165-1.307-.407-1.567-.667s-.502-.695-.667-1.568"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 8c0 .606.858.964 2.573 1.679l.529.22.22.528C7.037 12.142 7.394 13 8 13s.964-.858 1.679-2.573l.22-.529.528-.22C12.142 8.964 13 8.606 13 8s-.858-.963-2.573-1.678l-.528-.22-.22-.528C8.963 3.858 8.605 3 8 3s-.963.858-1.678 2.574l-.22.528-.529.22C3.858 7.037 3 7.394 3 8m4.173.828-1.061-.442c-.36-.15-.662-.276-.915-.386.253-.11.554-.236.915-.386l1.06-.442.442-1.06c.15-.36.277-.662.386-.915.11.253.236.554.386.915l.442 1.06 1.06.442c.36.15.662.277.915.386-.253.11-.554.236-.915.386l-1.06.442-.442 1.06c-.15.36-.276.662-.386.915-.11-.253-.235-.554-.386-.915z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
FrameStarOutlinedSize16Glyph.displayName = 'FrameStarOutlinedSize16Glyph';
